<template>
  <div class="doctor-selector">
    <div class="header-title">添加{{ isBeauty ? '美容师' : '医生' }}</div>
    <div class="header-setting__tip">最少添加2个{{ isBeauty ? '美容师' : '医生' }}</div>
    <div class="body-setting">
      <div class="doctor-grid">
        <div
          v-for="item in $$FormData.doctors.filter(item => item.id != null)"
          :key="item.__key"
          class="doctor-thumb"
        >
          <img :src="item.avatar" />
          <i class="remove" @click="removeDoctor(item.id)">×</i>
          <div class="name">{{ isBeauty ? item.beauticianName : item.doctorName }}</div>
        </div>
        <div class="doctor-add" @click="openDialog">
          <div class="plus">+</div>
          <div class="text">添加{{ isBeauty ? '美容师' : '医生' }}</div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="`选择${isBeauty ? '美容师' : '医生'}`"
      :visible.sync="visible"
      width="50%"
      append-to-body
    >
      <el-select
        v-model="clinic"
        placeholder="选择门诊"
        style="width: 100%; margin-bottom: 16px"
      >
        <el-option
          v-for="item in clinics"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>

      <el-table
        ref="doctorTable"
        :data="mockDoctors"
        border
        style="width: 100%"
        row-key="id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40" align="center" :reserve-selection="true" />
        <el-table-column :prop="isBeauty ? 'staffName' : 'staffName'" :label="`${isBeauty ? '美容师' : '医生'}名称`" align="center" />
        <el-table-column :prop="isBeauty ? 'beauticianName' : 'doctorName'"  :label="`${isBeauty ? '美容师' : '医生'}显示名称`" align="center" />
        <el-table-column prop="gender" label="性别" align="center" >
          <template slot-scope="scope">
            {{ scope.row.gender == 1 ? '男' : '女' }}
          </template>
        </el-table-column>
        <el-table-column prop="jobTitle" label="职称" align="center" />
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="confirm"> 确定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { uuid } from "@/utils/foundation";
import * as API_doctor from "@/api/doctor";

export default {
  name: "DoctorListSetting",
  data() {
    return {
      visible: false,
      clinic: "",
      clinics: [],
      selectedIds: [],
      token: "",
      storeId: "",
      mockDoctors: [
      ],
    };
  },
  computed: {
    isBeauty() {
      const businessType = this.$$Foundation.getURLSearchParma("businessType");
      return businessType === 'LIFE';
    },
  },
  mounted() {
    this.token = this.$$Foundation.getURLSearchParma("token");
    this.storeId = this.$$Foundation.getURLSearchParma("storeId");
    this.init();
  },
  watch: {
    clinic() {
      this.loadDoctors();
    },
    visible(val) {
      if (val) {
        // 打开弹窗时，从已选列表获取ID
        const selectedDoctorIds = this.$$FormData.doctors.map((item) => item.id);
        this.loadDoctors().then(() => {
          this.$nextTick(() => {
            if (this.$refs.doctorTable) {
              // 先清空所有选中
              this.$refs.doctorTable.clearSelection();
              // 再设置需要选中的行
              this.mockDoctors.forEach((doc) => {
                if (selectedDoctorIds.includes(doc.id)) {
                  this.$refs.doctorTable.toggleRowSelection(doc, true);
                }
              });
              this.selectedIds = selectedDoctorIds;
            }
          });
        });
      } else {
        // 关闭弹窗时清空选中
        this.$nextTick(() => {
          if (this.$refs.doctorTable) {
            this.$refs.doctorTable.clearSelection();
          }
        });
      }
    },
  },
  methods: {
    init() {
      API_doctor.storePage(
        {
          pageNo: 1,
          pageSize: 100,
          businessType: this.isBeauty ? 'LIFE' : 'MEDICAL',
        },
        this.token,
        this.isBeauty ? 'LIFE' : 'MEDICAL'
      ).then((res) => {
        if (!res || !res.data) {
          this.clinics = [];
          return;
        }
        let storeList = res.data.list || [];
        const storeIdStr = String(this.storeId || '');
        // 如果 storeId 包含逗号（多门店），则筛选出 id 在 storeId 列表中的门店
        if (storeIdStr.includes(',')) {
          const storeIdArr = storeIdStr.split(',').map(id => String(id).trim());
          storeList = storeList.filter(item => storeIdArr.includes(String(item.id)));
        } else if (this.storeId) {
          // 单门店，筛选出 id 相同的门店
          storeList = storeList.filter(item => String(item.id) === storeIdStr);
        }
        this.clinics = storeList;
        // 如果只有一个门店，自动选中
        if (this.clinics.length === 1) {
          this.clinic = this.clinics[0].id;
        }
      });
      this.loadDoctors();
    },
    loadDoctors() {
      return API_doctor.doctorPage(
        {
          pageNo: 1,
          pageSize: -1,
          storeId: this.clinic,
        },
        this.token,
        this.isBeauty ? 'LIFE' : 'MEDICAL'
      ).then((res) => {
        if (!res || !res.data || !res.data.list) {
          this.mockDoctors = [];
          return;
        }
        this.mockDoctors = res.data.list.filter((item) => item.id !== null);
      });
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.id);
    },
    openDialog() {
      this.visible = true;
    },
    confirm() {
      const newList = [];

      this.selectedIds.forEach((id) => {
        // 先从已选列表中查找
        let doc = this.$$FormData.doctors.find((d) => d.id === id);
        if (!doc) {
          // 如果已选列表中没有，则从弹窗列表中查找
          doc = this.mockDoctors.find((d) => d.id === id);
          if (doc) {
            doc = { ...doc, __key: uuid() };
          }
        }
        if (doc) {
          newList.push(doc);
        }
      });

      if (newList.length < 2) {
        this.$message.warning(`${this.isBeauty ? '美容师' : '医生'}最少添加 2 位${this.isBeauty ? '美容师' : '医生'}`);
        return;
      }
      this.$$FormData.doctors = newList;
      this.visible = false;
      this.$nextTick(() => {
        this.$refs.doctorTable.clearSelection();
      });
    },
    removeDoctor(id) {
      const newList = this.$$FormData.doctors.filter((item) => item.id !== id);
      this.$$FormData.doctors = newList;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-title {
  margin-left: 16px;
  font-size: 14px;
  color: #969799;
  line-height: 18px;
}
.header-setting__tip {
  margin-bottom: 10px;
  margin-left: 16px;
  color: #969799;
}

.doctor-item {
  margin-bottom: 6px;
  font-size: 14px;
}

.doctor-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 0 16px;
}

.doctor-thumb,
.doctor-add {
  width: 80px;
  height: 100px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  text-align: center;
  position: relative;
}

.doctor-thumb img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin:  0 auto;
  margin-top: 12px;
}

.doctor-thumb .name {
  font-size: 12px;
  margin-top: 6px;
}

.doctor-thumb .remove {
  position: absolute;
  right: -6px;
  top: -6px;
  width: 16px;
  height: 16px;
  background: #f56c6c;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
}

.doctor-add {
  cursor: pointer;
  color: #909399;
}

.doctor-add .plus {
  font-size: 28px;
  margin-top: 16px;
}

.doctor-add .text {
  font-size: 12px;
  margin-top: 4px;
}
</style>
